"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Styles = require("../../color/gradients/Styles");

var _BeakerIcon = _interopRequireDefault(require("./BeakerIcon"));

var _UIFloatingActionButton = _interopRequireDefault(require("../UIFloatingActionButton"));

var _colors = require("HubStyleTokens/colors");

var _HoverProvider = _interopRequireDefault(require("../../providers/HoverProvider"));

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding-left: ", ";\n  position: relative;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 54px;\n  left: 0;\n  position: absolute;\n  top: -24px;\n  width: 20px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  background-color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var hoveredStyles = (0, _styledComponents.css)(_templateObject(), _colors.OLAF, _colors.CALYPSO_DARK);
var BetaTheme = (0, _styledComponents.default)(_UIFloatingActionButton.default).withConfig({
  displayName: "UIBetaButton__BetaTheme",
  componentId: "m9zn66-0"
})(_templateObject2(), function (props) {
  return props.hovered ? hoveredStyles : _Styles.getBlueOceanGradient;
});
var StyledBeakerIcon = (0, _styledComponents.default)(_BeakerIcon.default).withConfig({
  displayName: "UIBetaButton__StyledBeakerIcon",
  componentId: "m9zn66-1"
})(_templateObject3());

var Inner = _styledComponents.default.span.withConfig({
  displayName: "UIBetaButton__Inner",
  componentId: "m9zn66-2"
})(_templateObject4(), function (props) {
  return props.icon === 'beaker' ? '26px' : 0;
});

var UIBetaButton = _react.default.createClass({
  displayName: "UIBetaButton",
  propTypes: (0, _extends2.default)({}, _UIFloatingActionButton.default.propTypes, {
    icon: _react.PropTypes.oneOf(['beaker', 'none'])
  }),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, _UIFloatingActionButton.default.defaultProps, {
      icon: 'beaker'
    });
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        icon = _this$props.icon,
        __useNativeButton = _this$props._useNativeButton,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "icon", "_useNativeButton"]);
    return _react.default.createElement(_HoverProvider.default, this.props, function (hoverProviderProps) {
      return _react.default.createElement(BetaTheme, (0, _extends2.default)({}, rest, hoverProviderProps), _react.default.createElement(Inner, {
        icon: icon
      }, icon === 'beaker' ? _react.default.createElement(StyledBeakerIcon, null) : null, children));
    });
  }
});

var _default = UIBetaButton;
exports.default = _default;
module.exports = exports.default;